import Input from './Input'
import NumberInput from './NumberInput'
import PasswordInput from './PasswordInput'

export { Input, NumberInput, PasswordInput }
export default Input
